<div class="wrapper wrapper-content animated fadeInRight">
  <app-scorecard
    [scoringType]="'group'"
    [scorecardMode]="'stats'"
    [hideOfficialScorecards]="false"
  ></app-scorecard>
</div>
